import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { getDefaultRedirectPath } from '../utils/redirectUtils';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body1" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  // Check if we're on the login page with an SSO code parameter
  // If so, allow the login page to process the SSO code even if user is authenticated
  const searchParams = new URLSearchParams(location.search);
  const hasSSOCode = searchParams.has('code');
  const isLoginPage = location.pathname === '/login';

  // If user is authenticated and NOT processing SSO, redirect to their default dashboard
  if (isAuthenticated && !(isLoginPage && hasSSOCode)) {
    const redirectPath = getDefaultRedirectPath(user);
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default PublicRoute;









